import {STATE_PROP_NAME} from './companies-table-constants'

export const getRoot = state => state[STATE_PROP_NAME]
export const getByKey = (key, state) => getRoot(state)[key]
